var map = {
	"./en-GB.ts": "5e0d",
	"./fr-FR.ts": "7f53",
	"./it-IT.ts": "2dd6",
	"./nl-NL.ts": "54b6",
	"./pl-PL.ts": "8e82",
	"./pt-BR.ts": "79db"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e7b6";